import ColorVariant from '../../../../../components/ColorVariant/ColorVariant';
import {
  VariantDescriptionFilterContainer,
  VariantDescriptionFilterContent,
  VariantDescriptionFilterHeading,
  ActiveVariantName,
} from '../../VariantDescription/VariantDescription.styles';

function VariantColors(props) {
  const { item, index, activeVariant } = props;
  return (
    <VariantDescriptionFilterContainer key={`variant-category-${Object.keys(item)[0]}`}>
      <VariantDescriptionFilterHeading>
        {Object.keys(item)[0]}:
        <ActiveVariantName>
          {activeVariant?.option_variant_names?.[index]?.variant_name || ''}
        </ActiveVariantName>
      </VariantDescriptionFilterHeading>
      <VariantDescriptionFilterContent isColor>
        {item[Object.keys(item)[0]].map((item_variants) => {
          return (
            activeVariant && (
              <ColorVariant
                key={`specific-variant-${item_variants?.variant_name}`}
                color={item_variants?.colour_code}
                isPdp
                toggleClick={props?.toggleClick}
                outOfVisbleInfo={props?.outOfVisbleInfo}
                outOfStockInfo={props?.outOfStockInfo}
                isSelectedOption={props?.isSelectedOption}
                activeVariantOption={props?.activeVariantOption}
                handleVariantBtnClick={props?.handleVariantBtnClick}
                rowIndex={index}
                variantName={item_variants?.variant_name}
                activeIdx={props?.activeIdx}
                returnIsVariantVisible={props?.returnIsVariantVisible}
                returnIsVariantAvailable={props?.returnIsVariantAvailable}
                themeColor={props?.storeInfo?.theme?.colors?.primary_color}
                storeTheme={props?.storeInfo?.theme}
              />
            )
          );
        })}
      </VariantDescriptionFilterContent>
    </VariantDescriptionFilterContainer>
  );
}

export default VariantColors;
